
import axios from './axiosConfig';
//import { createBrowserHistory } from "history";
//const API_URL = "https://api.demo2.raborisk.ai";
const API_URL = process.env.NODE_ENV === 'production' 
    ? "https://api.demo2.raborisk.ai" 
    : "http://localhost:3000";

    
export const resetGotoIncident = () => {
    return (dispatch) => {
        dispatch({ type: "RESET_GOTO_INCIDENT" });
    };
};

export const gotoIncident = (risk_id) => {
    return (dispatch) => {
        dispatch({ type: "GOTO_INCIDENT", risk_id: risk_id });
    };
};

export const getIncidents = (risk_id) => {
    return (dispatch) => {
        axios.get(API_URL + "/api/risk/get_incidents/" + risk_id)
            .then(({ data }) => {
                dispatch({ type: "INCIDENTS", incidents: data });
            });
    };
};

export const getIncidentsDepartment = (department_id) => {
    return (dispatch) => {
        axios.get(API_URL + "/api/risk/get_department_incidents?department_id=" + department_id)
            .then(({ data }) => {
                dispatch({ type: "INCIDENTS", incidents: data });
            });
    };
};


export const getIncidentsCompliance = (compliance_id) => {
    return (dispatch) => {
        axios.get(API_URL + "/api/risk/get_compliance_incidents?compliance_id=" + compliance_id)
            .then(({ data }) => {
                console.log("Incidents ", data)
                dispatch({ type: "INCIDENTS", incidents: data });
            });
    };
};

export const getIncident = (incident_id) => {
    return (dispatch) => {
        axios.get(API_URL + "/api/risk/get_incident/" + incident_id)
            .then(({ data }) => {
                dispatch({ type: "INCIDENT", incident: data });
            });
    };
};

export const closeIncident = () => {
    return (dispatch) => {
        dispatch({ type: "CLOSE_INCIDENT"});
    };
};

export const saveIncident = (incident_id, incident) => {
    return (dispatch) => {
        axios.post(API_URL + "/api/risk/save_incident/" ,  { incident_id: incident_id, incident: incident })
            .then(({ data }) => {
                //dispatch({ type: "INCIDENT", incident: data });
            });
    };
};

export const deleteIncident = (incident_id, incident) => {
    return (dispatch) => {
        axios.post(API_URL + "/api/risk/delete_incident/" ,  { incident_id: incident_id, incident: incident })
            .then(({ data }) => {
                //dispatch({ type: "INCIDENT", incident: data });
            });
    };
};

